import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { inject } from 'mobx-react';
import { EDITOR_SHOTS_STORE } from 'store';
import { ShotView } from 'components';
import { ShotViewContentProps } from './types';

const ShotViewContent = (props: ShotViewContentProps) => {
  const {
    [EDITOR_SHOTS_STORE]: {
      sortedShotsFilteredBySelectedLocation: shotList,
      onVovWizardShotClick
    }
  } = props;

  useEffect(() => {
    // Disables the default document text select when shift+click
    const checkForShiftKey = e => {
      document.onselectstart = () => {
        return !(e.key === 'Shift' && e.shiftKey);
      };
    };

    const eventTypes = ['keyup', 'keydown'];
    eventTypes.forEach(evenType => {
      window.addEventListener(evenType, checkForShiftKey, false);
    });

    return () => {
      eventTypes.forEach(eventType => {
        window.removeEventListener(eventType, checkForShiftKey, false);
      });
    };
  }, []);

  return (
    <>
      {shotList.map((shot, index) =>
        <ShotView
          key={index}
          shot={shot}
          hideActions
          onClick={e => onVovWizardShotClick(e, index)}
        />
      )}
    </>
  );
};

export default inject(EDITOR_SHOTS_STORE)(observer(ShotViewContent));
